import React from 'react';
export const VIDEO_URL = 'https://quality-static-frontbase.operabase.net/landing_pages/Casting Tool video.MOV';

export const ARTIST_SLIDER_CONTENT = [
  {
    name: 'Liviu Holender',
    profession: 'Baritone',
    comment: `Operabase is a “living” library of opera, it's the most efficient practical tool to search for artists and opera houses around the world and connects the world of opera. Whatever you are looking for; Operabase will provide the answer…Of course, it’s a huge benefit to all artists and the opera world.`,
    src:
      'https://res.cloudinary.com/dph1uc7fk/image/fetch/c_fill,f_auto,g_face,h_420,q_100,w_320/https://static.truelinked.com/profiles/5658a08e-b512-4b67-b053-35f43e00fdd9/liviu-holender-large.png',
    href: 'https://www.operabase.com/artists/liviu-holender-32081/en',
  },
  {
    name: 'Marina Viotti',
    profession: 'Mezzo-soprano',
    comment: `Operabase is the tool I use to see where and when this soprano I like performs for instance. Or with whom I’m gonna perform with next month. It’s at the same time the best agenda but also it gathers all the information about opera houses, programs, artists. It’s really the Bible of the opera world!`,
    src:
      'https://res.cloudinary.com/dph1uc7fk/image/fetch/c_fill,f_auto,g_face,h_420,q_100,w_320/https://static.truelinked.com/profiles/80a4ae2c-f42d-4989-bef2-e8280bac01a3/marina-viotti-large.png',
    href: 'https://www.operabase.com/artists/marina-viotti-31671/en',
  },
  {
    name: 'Iurii Samoilov',
    profession: 'Baritone',
    comment:
      'Very delighted to be featured as an artist of the week by Operabase…If you didn’t know Operabase is the biggest platform featuring artists, their schedules and many other important information.',
    src:
      'https://s3-eu-west-2.amazonaws.com/askonasholt-images/wp-content/uploads/2014/07/28155146/2Q1A9306%C3%90%C3%A4-e1492615432138.jpg',
    href: 'https://www.operabase.com/artists/iurii-samoilov-19387/en',
  },
  {
    name: 'Olena Tokar',
    profession: 'Soprano',
    comment: 'Operabase you are the best.',
    src:
      'https://res.cloudinary.com/dph1uc7fk/image/fetch/c_thumb,f_auto,g_face,h_100,q_100,w_75,z_0.7/https://static.truelinked.com/profiles/274308f6-ed74-4b50-823d-e6af25ff4773/olena-tokar-medium.png',
    href: 'https://www.operabase.com/artists/olena-tokar-19050/en',
  },
  {
    name: 'Channa Malkin',
    profession: 'Soprano',
    comment:
      'Small recap on what Operabase shared last week, as I was their artist of the week! Operabase is a life-saver for us who work in the opera world. I loved being part of this, thank you!💓',
    src:
      'https://res.cloudinary.com/dph1uc7fk/image/fetch/c_fill,f_auto,g_face,h_420,q_100,w_320/https://static.truelinked.com/profiles/64da803f-7c8d-4754-a423-0748cde37a4b/channa-malkin-large.png',
    href: 'https://www.operabase.com/artists/channa-malkin-115212/en',
  },
];

export const ARTIST_SLIDER_COMMENTS = [
  [
    {
      name: 'Liviu Holender',
      profession: 'Baritone',
      comment: `Operabase is a “living” library of opera, it's the most efficient practical tool to search for artists and opera houses around the world and connects the world of opera. Whatever you are looking for; Operabase will provide the answer…Of course, it’s a huge benefit to all artists and the opera world.`,
      src:
        'https://res.cloudinary.com/dph1uc7fk/image/fetch/c_fill,f_auto,g_face,h_420,q_100,w_320/https://static.truelinked.com/profiles/5658a08e-b512-4b67-b053-35f43e00fdd9/liviu-holender-large.png',
      href: 'https://www.operabase.com/artists/liviu-holender-32081/en',
    },
    {
      name: 'Marina Viotti',
      profession: 'Mezzo-soprano',
      comment: `Operabase is the tool I use to see where and when this soprano I like performs for instance. Or with whom I’m gonna perform with next month. It’s at the same time the best agenda but also it gathers all the information about opera houses, programs, artists. It’s really the Bible of the opera world!`,
      src:
        'https://res.cloudinary.com/dph1uc7fk/image/fetch/c_fill,f_auto,g_face,h_420,q_100,w_320/https://static.truelinked.com/profiles/80a4ae2c-f42d-4989-bef2-e8280bac01a3/marina-viotti-large.png',
      href: 'https://www.operabase.com/artists/marina-viotti-31671/en',
    },
  ],
  [
    {
      name: 'Iurii Samoilov',
      profession: 'Baritone',
      comment:
        'Very delighted to be featured as an artist of the week by Operabase…If you didn’t know Operabase is the biggest platform featuring artists, their schedules and many other important information.',
      src:
        'https://s3-eu-west-2.amazonaws.com/askonasholt-images/wp-content/uploads/2014/07/28155146/2Q1A9306%C3%90%C3%A4-e1492615432138.jpg',
      href: 'https://www.operabase.com/artists/iurii-samoilov-19387/en',
    },
    {
      name: 'Olena Tokar',
      profession: 'Soprano',
      comment: 'Operabase you are the best.',
      src:
        'https://res.cloudinary.com/dph1uc7fk/image/fetch/c_thumb,f_auto,g_face,h_100,q_100,w_75,z_0.7/https://static.truelinked.com/profiles/274308f6-ed74-4b50-823d-e6af25ff4773/olena-tokar-medium.png',
      href: 'https://www.operabase.com/artists/olena-tokar-19050/en',
    },
  ],
  [
    {
      name: 'Channa Malkin',
      profession: 'Soprano',
      comment:
        'Small recap on what Operabase shared last week, as I was their artist of the week! Operabase is a life-saver for us who work in the opera world. I loved being part of this, thank you!💓',
      src:
        'https://res.cloudinary.com/dph1uc7fk/image/fetch/c_fill,f_auto,g_face,h_420,q_100,w_320/https://static.truelinked.com/profiles/64da803f-7c8d-4754-a423-0748cde37a4b/channa-malkin-large.png',
      href: 'https://www.operabase.com/artists/channa-malkin-115212/en',
    },
  ],
];

export const ARTIST_SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 5000,
  slidesToShow: 1,
  // autoplay: true,
  autoplaySpeed: 4000,
  centerMode: true,
  centerPadding: '0px',
  fade: false,
  slidesToScroll: 1,
  arrows: false,
  appendDots: dots => (
    <ul>
      <span>{dots}</span>
    </ul>
  ),
};
